import { constructEmails } from "../Factory/factory";
import { REVIEW_NOTIFICATION_EMAILS } from "../Reducers/reviewNotificationEmailsReducer";
import { WEEKLY_NOTIFICATION_EMAILS } from "../Reducers/weeklyNotificationEmailsReducer";
import { findNotificationEmails, updateNotificationEmails, findReviewNotificationEmails, updateReviewNotificationEmails } from "../Util/queries";

export const getWeeklyNotificationEmails = () => async (dispatch) => {
    let emailsObj
    try {
        const response = await findNotificationEmails();
        emailsObj = constructEmails(response.data);  
    } catch (e) {
        console.error(e);
        emailsObj = constructEmails([]);  
    }

    dispatch({
        type: WEEKLY_NOTIFICATION_EMAILS,
        payload: emailsObj,
    })
};

export const setWeeklyNotificationEmails = (emails) => async (dispatch) => {
    try {
        const response = await updateNotificationEmails(emails);
        const emailsObj = constructEmails(response.data);
        dispatch({
            type: WEEKLY_NOTIFICATION_EMAILS,
            payload: emailsObj,
        })
    } catch (e) {
        console.error(e);
    }
}


export const getReviewNotificationEmails = () => async (dispatch) => {
    let emailsObj;
    try {
        const response = await findReviewNotificationEmails();
        emailsObj = constructEmails(response.data.emails);
    } catch (e) {
        console.error(e);
        emailsObj = constructEmails([]);
    }
    dispatch({
        type: REVIEW_NOTIFICATION_EMAILS,
        payload: emailsObj,
    });
};

export const setReviewNotificationEmails = (emails) => async (dispatch) => {
    try {
        const payload = {
            emails: emails,
        }
        const response = await updateReviewNotificationEmails(payload);
        const emailsObj = constructEmails(response.data.emails);
        dispatch({
            type: REVIEW_NOTIFICATION_EMAILS,
            payload: emailsObj,
        });
    } catch (e) {
        console.error(e);
    }
};
